<template>
  <div id="app">
    <router-view v-on:play="playNow" v-on:viewContent="viewContent"
      v-on:login="$refs.loginModal.open()"/>
    <Footer/>
    <Player ref="player"/>
    <ImageViewer ref="imageViewer"/>
    <LoginModal ref="loginModal"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from '@/components/Footer.vue';
import Player from '@/components/Player.vue';
import ImageViewer from '@/components/ImageViewer.vue';
import LoginModal from '@/components/LoginModal.vue';

export default {
  name: 'home',
  components: {
    Footer,
    Player,
    ImageViewer,
    LoginModal,
  },
  data() {
    return {
    };
  },
  methods: {
    playNow(item) {
      this.$refs.player.play(item);
    },
    viewContent(item) {
      this.$refs.imageViewer.view(item);
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700;800&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400&display=swap');

  html {
    scroll-behavior: smooth;
  }
  body{
    margin: 0; padding: 0;
    font-family: 'Open Sans', sans-serif;
    color: #444;
    font-family: 'Nunito Sans', sans-serif;
    // padding-top: 60px;
    &.hideoverflow{
      overflow: hidden;
    }
    &.selectingMedia{
      footer, header, .editorFooter{ display: none; }
    }
    &.editorOpen{
      footer{ display: none; }
    }
  }
  button, input, textarea, select{
    font-family: 'Nunito Sans', sans-serif;
  }
  .btnGradient{
    border: none;
    background-color: #519EF3;
    background-image: linear-gradient(160deg, #57aeff, #3e6ecf);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    outline: 0;
  }
  .btnOutline{
    border: #3E6ECF 1px solid;
    color: #3E6ECF !important;
    background: none;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    outline: 0;
  }
  .sectionTitle{
    font-weight: bold;
    font-size: 30px;
    margin: 0;
    @media (max-width: 760px) {
      font-size: 24px;
    }
  }
  section.page{
    min-height: calc(100vh - 100px);
  }
  .btn{
    background: #fff;
    border-radius: 50px;
    color: #000;
    box-shadow: none;
    font-weight: lighter;
    padding: 4px 16px;
    font-size: 14px;
    padding-left: 36px;
    position: relative;
    transition: all .4s ease;
    cursor: pointer;
    font-weight: 600;
    display: inline-block;
    span{
      position: relative;
      z-index: 2;
    }
    .btnL{
      width: 25px; height: 25px;
      border-radius: 50px;
      background-color: #000;
      position: absolute;
      left: 1px; top: 1px;
      transition: all .3s ease;
      background-image: url(assets/right-arrow-notail-white.png);
      background-size: 13px auto;
      background-position: 7px 50%;
      background-repeat: no-repeat;
    }
    .btnL2{
      width: 25px; height: 25px;
      border-radius: 50px;
      position: absolute;
      left: 1px; top: 1px;
      transition: all .3s ease;
      background-image: url(assets/right-arrow-notail-white.png);
      background-size: 13px auto;
      background-position: 7px 50%;
      background-repeat: no-repeat;
    }
    &:hover{
      color: #fff;
      .btnL{
        width: calc(100% - 2px);
      }
      .btnL2{
        left: 10px;
      }
    }
  }

  .field{
    border: #ccc 1px solid;
    border-radius: 5px;
    padding: 12px 14px 10px;
    font-size: 17px;
    background-color: #fff;
    outline: 0;
    box-shadow: none;
    width: 100%;
    box-sizing: border-box;
    line-height: 1.4;
    &:hover{
      border-color: #fff;
      box-shadow: 0 0 0 2px #999;
    }
    &:focus{
      border-color: #fff;
      box-shadow: 0 0 0 2px #0b845c;
    }
  }
  .fieldError{
    color: red;
    font-size: 12px;
    margin: 6px 0 0 7px;
  }
  .fieldHint{
    color: #767676;
    font-size: 12px;
    margin: -2px 0 0;
    padding: 0 0 0 7px;
  }
  .fieldGroup{
    margin-bottom: 16px;
    .fieldCnt{
      position: relative;
      &.hasError{
        .field{
          border-color: #fff;
          box-shadow: 0 0 0 2px red;
        }
        .fieldError{
          display: block;
        }
        .hint{
          display: none;
        }
      }
      &.hasPrefix{
        .field{
          padding-left: 60px;
        }
        .prefix{
          position: absolute;
          left: 1px; top: 1px; bottom: 1px;
          background-color: #eee;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 5px 0 0 5px;
          padding: 0 10px;
          border-right: #e5e5e5 1px solid;
        }
      }
      .showPwd{
        width: 30px; height: 30px;
        position: absolute;
        right: 8px; top: 50%;
        margin-top: -15px;
        border-radius: 50%;
        background-image: url(assets/eye-closed.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        transition: all .3s ease;
        opacity: .8;
        &:hover{
          background-color: #eee;
          opacity: 1;
        }
        &.show{
          background-image: url(assets/eye.png);
        }
      }
    }
    &.hasError{
      .field{
        border-color: #fff;
        box-shadow: 0 0 0 2px red;
      }
      .hint{
        display: none;
      }
    }
  }


  @media (max-width: 1360px) {
    #app{
      .pages{
        .pagesCnt{
          height: 520px;
        }
        .pagesWrapper{
          max-width: 1024px;
        }
      }
      .section{
        max-width: 1024px;
      }
      .classCnt{
        .kelasIklimCnt{
          max-width: 1024px;
          .imgL{
            height: 520px;
          }
          .contentR{
            h4{
              font-size: 60px;
            }
            h5{
              font-size: 24px;
            }
            h3{
              font-size: 28px;
            }
          }
        }
      }
      .pageInfoWrapper{
        max-width: 1024px;
      }
      .sectionContent .sectionItem .sectionImg{
        height: 240px;
      }
      .infografis .infografisCnt{
        max-width: 1024px;
        .sectionContent .sectionItem .sectionImg{
          height: 430px;
        }
      }
      .kelasIklimCnt{
        max-width: 1024px;
        .kelas-iklim-item .itemImg{
          height: 240px;
        }
      }
      .beraksiCnt{
        .kelasIklimCnt{
          max-width: none;
          .kelasIklim{
            max-width: 1024px;
          }
        }
      }
      .beraksiCnt{
        .whatCanWeDoCnt{
          max-width: 1024px;
        }
        .whatCanWeDoImg{
          .imgWrapper{
            max-width: 1024px;
          }
        }
      }
      .jadwalAksiCnt{
        max-width: 1024px;
      }
    }
  }

  @media (max-width: 1160px) {
    #app{
      .pages{
        .pagesCnt{
          height: 460px;
        }
        .pagesWrapper{
          max-width: 960px;
        }
      }
      .section{
        max-width: 960px;
      }
      .classCnt{
        .kelasIklimCnt{
          max-width: 960px;
          .imgL{
            height: 460px;
          }
          .contentR{
            h4{
              font-size: 60px;
            }
            h5{
              font-size: 24px;
            }
            h3{
              font-size: 26px;
            }
          }
        }
      }
      .pageInfoWrapper{
        max-width: 960px;
      }
      .sectionContent .sectionItem .sectionImg{
        height: 225px;
      }
      .infografis .infografisCnt{
        max-width: 960px;
        .sectionContent .sectionItem .sectionImg{
          height: 400px;
        }
      }
      .kelasIklimCnt{
        max-width: 960px;
        .kelas-iklim-item .itemImg{
          height: 225px;
        }
      }
      .beraksiCnt{
        .kelasIklimCnt{
          max-width: none;
          .kelasIklim{
            max-width: 960px;
          }
        }
      }
      .beraksiCnt{
        .whatCanWeDoCnt{
          max-width: 960px;
        }
        .whatCanWeDoImg{
          .imgWrapper{
            max-width: 960px;
          }
        }
      }
      .jadwalAksiCnt{
        max-width: 960px;
      }
      footer .footerMenu .menuItem ul li{
        font-size: 17px;
      }
    }
  }

  @media (max-width: 990px) {
    #app{
      .pages{
        .pagesWrapper{
          margin-left: 20px;
          margin-right: 20px;
        }
      }
      .section{
        margin-left: 20px;
        margin-right: 20px;
      }
      .classCnt{
        .kelasIklimCnt{
          margin-left: 20px;
          margin-right: 20px;
          .imgL{
            height: 460px;
          }
          .contentR{
            h4{
              font-size: 110px;
            }
            h5{
              font-size: 44px;
              margin-top: -10px;
            }
            h3{
              font-size: 40px;
            }
          }
        }
      }
      .pageInfoWrapper{
        margin-left: 20px;
        margin-right: 20px;
      }
      .sectionContent .sectionItem{
        width: calc(33.333% - 20px);
        .sectionImg{
          height: 30vw;
        }
      }
      .infografis .infografisCnt{
        margin-left: 20px;
        margin-right: 20px;
        .sectionContent .sectionItem .sectionImg{
          height: 400px;
        }
      }
      .kelasIklimCnt{
        margin-left: 20px;
        margin-right: 20px;
        .kelas-iklim-item{
          width: calc(33.333% - 20px);
          .itemImg{
            height: 30vw;
          }
        }
      }
      .beraksiCnt{
        .kelasIklimCnt{
          max-width: none;
          margin: 40px 0;
          .kelasIklim{
            margin-left: 20px;
            margin-right: 20px;
          }
        }
      }
      .beraksiCnt{
        .whatCanWeDoCnt{
          margin-left: 20px;
          margin-right: 20px;
        }
        .whatCanWeDoImg{
          .imgWrapper{
            margin-left: 20px;
            margin-right: 20px;
          }
        }
      }
      .jadwalAksiCnt{
        margin-left: 20px;
        margin-right: 20px;
      }
      footer .footerMenu .menuItem ul li{
        font-size: 17px;
      }
    }
  }

  @media (max-width: 760px) {
    #app{
      .classCnt{
        .kelasIklimCnt{
          margin-left: 20px;
          margin-right: 20px;
          .imgL{
            height: 460px;
          }
          .contentR{
            .theContent{
              width: 100%;
            }
            h4{
              font-size: 50px;
            }
            h5{
              font-size: 20px;
              margin-top: 0;
            }
            h3{
              font-size: 20px;
              margin: 0;
            }
          }
        }
      }
      .sectionContent .sectionItem{
        width: calc(100% - 20px);
        .sectionImg{
          height: calc(100vw - 40px);
          border-radius: 10px;
          overflow: hidden;
        }
      }
      .infografis .infografisCnt{
        .sectionContent .sectionItem .sectionImg{
          height: calc(100vw - 40px);
        }
      }
      .kelasIklimCnt{
        .kelas-iklim-item{
          width: calc(100% - 20px);
          .itemImg{
            height: calc(100vw - 40px);
            overflow: hidden;
            border-radius: 10px;
          }
        }
      }
      .beraksiCnt{
        .kelasIklimCnt{
          max-width: none;
          margin: 40px 0;
          .kelasIklim{
            margin-left: 20px;
            margin-right: 20px;
          }
        }
      }
      .beraksiCnt{
        .whatCanWeDoCnt{
          margin-left: 20px;
          margin-right: 20px;
        }
        .whatCanWeDoImg{
          .imgWrapper{
            margin-left: 20px;
            margin-right: 20px;
          }
        }
      }
      .jadwalAksiCnt{
        margin-left: 20px;
        margin-right: 20px;
      }
      footer .footerMenu .menuItem ul li{
        font-size: 17px;
      }
    }
  }


#beraksi.page4 header{
  .menuToggle{
    background-image: url(assets/menu.png);
  }
  .logo{
    opacity: 1;
    &.white{
      opacity: 0;
    }
  }
  .menu{
    .menuItem{
      color: #444;
      &:hover{
        color: #444;
      }
    }
  }
}
</style>
